import { UserType } from '@/entities/user'
import { apiClient, Pagination, PaginationSearchParams } from '@/shared/api'

import { TNoticeSummary } from '../model/schema'

export type TGetNoticesParams = {
  userType: UserType
  searchParams: PaginationSearchParams
}

export const getNotices = async ({
  userType,
  searchParams,
}: TGetNoticesParams) => {
  const response = await apiClient.get<Pagination<TNoticeSummary>>({
    endpoint: `/support/${userType}/notices`,
    queryParams: {
      ...searchParams,
      size: 10,
    },
  })

  return response
}
